module.exports = __webpack_public_path__ + "media/images/pic/brodno/offer/team-b48b3236dd82929a4b5cb357629ca165.jpg";